// 背贴码扫码录入通用能力：防连击重复提交锁 + 已扫列表去重追加。
// 背贴码校验是异步接口，原逻辑要等接口返回才清空输入框，连续点击【确定】或重复回车会对同一背贴码发起多次请求，
// 并发返回时同一个背贴码被重复 push 进已扫列表，页面出现重复数据；此处按背贴码加锁，请求返回前不再重复提交。
// 锁带过期时间：@deanwu request 在超时/取消分支不会回调 complete，靠过期时间自动解锁，避免该码永久无法再扫。
const LOCK_EXPIRE = 15000;

export default {
    data() {
        return {
            scanCodeLocks: []       //校验中的背贴码 [{code, expire}]
        };
    },

    methods: {
        /*********背贴码是否正在校验中（顺带清理过期锁）**********/
        isScanCodePending(code) {
            var now = Date.now();
            this.scanCodeLocks = this.scanCodeLocks.filter(item => item.expire > now);
            return this.scanCodeLocks.some(item => item.code == code);
        },

        /*********标记背贴码开始校验**********/
        lockScanCode(code) {
            this.scanCodeLocks.push({code: code, expire: Date.now() + LOCK_EXPIRE});
        },

        /*********解除背贴码校验锁**********/
        unlockScanCode(code) {
            this.scanCodeLocks = this.scanCodeLocks.filter(item => item.code != code);
        },

        /*********追加已扫项（同一背贴码并发返回时只保留一条）**********/
        pushScannedItem(data, code) {
            var target = code || (data && data.produce_unique_code);
            if (target && this.scannedList.some(item => item.produce_unique_code == target)) {
                this.$message({message: '该背贴码已扫描', type: 'warn'});
                return false;
            }
            this.scannedList.push(data);
            return true;
        }
    }
};
